import '@openhps/rdf';
//# sourceMappingURL=index.js.map